export function getUtteranceId(utterance, containerId) {
  const baseId = `utterance-${utterance.id}`;
  return containerId ? `${containerId}-${baseId}` : baseId;
}